<template>
  <div>
    <draggable
      v-model="fileList"
      class="list-group"
      tag="ul"
      v-bind="dragOptions"
      @start="productForm.drag = true"
      @end="productForm.drag = false"
    >
      <transition-group>
        <div v-for="(item) in fileList" :key="item.url" class="listitem">
          <img
            v-if="item.url"
            :src="$preffix+'?type=1&vedioName='+item.url+'&token='+token"
            width="127"
            class="imgSty"
            :title="item.fileName"
          />
          <span class="del">
            <i class="el-icon-delete delIcon" @click="handleRemove(item)" />
          </span>
        </div>
      </transition-group>
    </draggable>

    <el-upload
      ref="load"
      :action="$server + '/upload/uploadImg'"
      :headers="{ Authorization: token }"
      multiple
      :on-success="fileSuccess"
      accept="image/jpg, image/jpeg, image/png"
      list-type="picture-card"
      :auto-upload="true"
      :show-file-list="false"
      :data="{compressFlag: 1}"
      class="help"
    >
      <i slot="default" class="el-icon-plus"></i>
    </el-upload>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
// import { debounce } from 'throttle-debounce'
export default {
  name: 'multipleUpload',
  components: { draggable },
  props: {
    list: Array
  },
  data () {
    return {
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      token: window.localStorage.getItem('token'),
      orgId: JSON.parse(window.localStorage.getItem('userInfo')).orgId + '/',
      productForm: {
        currentDelBtn: -1,
        drag: false
      },
      imgList: [],
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    };
  },
  created () {
    this.fileList = this.list.map(v => { return { url: v } });
  },
  methods: {
    fileSuccess (res, file, fileList) {
      console.log(res, file, fileList);
      if (res.success) {
        this.fileList.push({ url: res.data.newImgName, uid: file.uid, fileName: res.data.oldImgName });
        file.url = res.data.newImgName;
        this.$emit('getFilelist', this.fileList)
        // debounce(300,this.imgListSort())
      } else {
        this.$message.error(res.message);
      }
    },
    handleRemove (file, fileList) {
      this.$confirm('删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除数据
        this.fileList.forEach((v, i) => {
          if (v.url === file.url && v.uid === file.uid) {
            this.fileList.splice(i, 1);
          }
        });
        this.$emit('getFilelist', this.fileList)
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
};
</script>
<style lang="scss">
.help .el-upload--picture-card {
  width: 125px;
  height: 222px;
  position: relative;
}
</style>
<style lang="scss" scoped>
.title {
  font-size: 13px;
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.imgSty {
  margin-left: 3px;
}
.delIcon {
  color: #fff;
  font-size: 20px;
  float: right;
  margin-top: 5px;
  margin-right: 5px;
}
.listitem {
  width: 125px;
  height: 222px;
  float: left;
  margin-right: 10px;
  position: relative;
  margin-bottom: 25px;
}
.listitem:hover .del {
  display: block;
}
.del {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 10px;
  background: rgba(0, 0, 0, 0.1);
  display: none;
  cursor: pointer;
  border-radius: 4px;
}

.el-icon-plus:before {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.help {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/common/multipleUpload.vue